import {
  DVIRReviewFormDefaultValues,
  DVIRReviewFormProps,
  DVIRReviewFormRawValues,
  DVIRReviewFormType
} from "./DVIRReviewForm";
import {useTranslation} from "react-i18next";
import {useForm} from "@mantine/form";
import {isStringUndefinedOrBlank} from "@ots-frontend/ots-data";

const getInitialValues = (defaultValues: DVIRReviewFormDefaultValues | undefined): DVIRReviewFormRawValues => {
  let defects: ("corrected" | "not_needed") | undefined = undefined

  if (defaultValues?.defectsCorrected !== defaultValues?.defectsNeedNotCorrected) {
    defects = defaultValues?.defectsCorrected ? "corrected" : "not_needed"
  }

  return {
    defects: defects,
    comments: defaultValues?.comments,
  }
}

export type UseDVIRReviewFormProps = Pick<DVIRReviewFormProps, 'defaultValues'> & {}

export function useDVIRReviewForm(props: UseDVIRReviewFormProps): DVIRReviewFormType {
  const {
    defaultValues
  } = props

  const {t} = useTranslation(["common"])

  const form = useForm({
    initialValues: getInitialValues({
      ...defaultValues,
    }),
    validate: {
      defects: (value) => !isStringUndefinedOrBlank(value) ? undefined : t("common.validation.required", "Required"),
      comments: (value) => !isStringUndefinedOrBlank(value) ? undefined : t("common.validation.required", "Required"),
    },
  })

  return form
}
